import { useEffect } from 'react';

/**
 * Hook that ensures the active navigation element is always in view
 * in case the NavigationBreadcrumb is scrollable (i.e in mobile).
 *
 * @param {Object} containerRef The container (NavigationBreadcrumb) ref.
 * @param {Object} activeNavRef The active nav ref.
 * @param {number} activeIndex The active index.
 */
const useNavigationBreadcrumbScroll = (
  containerRef,
  activeNavRef,
  activeIndex,
) => {
  useEffect(() => {
    if (!containerRef.current || !activeNavRef.current) {
      return;
    }

    const containerLeft = containerRef.current.scrollLeft;
    const containerRight = containerLeft + containerRef.current.clientWidth;

    const elementLeft =
      activeNavRef.current.offsetLeft - containerRef.current.offsetLeft;
    const elementRight = elementLeft + activeNavRef.current.clientWidth;

    // The element is fully visible in the container, do nothing.
    if (elementLeft >= containerLeft && elementRight <= containerRight) {
      return;
    }

    // The element is partially hidden on its left, scroll to the left.
    if (elementLeft < containerLeft) {
      // eslint-disable-next-line no-param-reassign
      containerRef.current.scrollLeft -= containerLeft - elementLeft;
    }

    // The element is partially hidden on its right, scroll to the right.
    if (elementRight > containerRight) {
      // eslint-disable-next-line no-param-reassign
      containerRef.current.scrollLeft += elementRight - containerRight;
    }
  }, [containerRef?.current, activeNavRef?.current, activeIndex]);
};

export default useNavigationBreadcrumbScroll;
